@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.tabs {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.tabs-header {
  display: flex;
  border-bottom: 1px solid @tabs--tabs-header--border-bottom-color;
  width: 100%;
}

.tabs-body {
  width: 100%;
  flex-grow: 1;
  max-height: calc(100% - 41px);
}
